module.exports = __webpack_public_path__ + "static/media/icons_Bilan Lymphoedème.267fd782.svg";